export default {
  zh: {
    keyword: '关键字',
    keywordPlaceholder: '请输入批次号或文件名',
    uploadDate: '上传时间',
    batchNo: '批次号',
    fileName: '文件名',
    creatorName: '上传人',
    createTime: '创建时间',
    totalCount: '总条数',
    totalAmount: '总金额',
    rejectCount: '驳回条数',
    rejectReason: '驳回原因',
    paymentCount: '放款数量',
    paymentAmount: '放款金额',
    status: '状态',
    statusPlaceholder: '请选择状态',
    updateTime: '更新时间',
    action: '操作',
    createPayrollBatch: '新建发薪批次',
    payrollDetail: '发薪批次详情',
    batchBaseInfo: '发薪批次基础信息',
    batchDetailInfo: '发薪批次详细信息',
    allCount: '总条数',
    allAmount: '总金额',
    effectiveCount: '有效条数(未取消)',
    effectiveAmount: '有效金额(未取消)',
    userNo: '催收员账号',
    userNoPlaceholder: '请输入催收员账号',
    employeeName: '催收员名称',
    employeeNamePlaceholder: '请输入催收员名称',
    account: '发薪银行账号',
    accountPlaceholder: '请输入发薪银行账号',
    onlyRejectData: '只看驳回数据',
    waitRejectCount: '待驳回条数',
    groupId: '分组',
    waitRejectData: '查看驳回数据'

  },
  ti: {
    keyword: 'คำสำคัญ',
    keywordPlaceholder: 'โปรดป้อนหมายเลขล็อตหรือชื่อแฟ้ม',
    uploadDate: 'เวลาอัพโหลด',
    batchNo: 'หมายเลขล็อต',
    fileName: 'ชื่อแฟ้ม',
    creatorName: 'อัพโหลดโดย',
    createTime: 'สร้างเวลา',
    totalCount: 'จำนวนแถบที่ถูกต้อง',
    totalAmount: 'จำนวนเงินที่ถูกต้อง',
    rejectCount: 'จำนวนรายการที่ถูกยกเลิก',
    rejectReason: 'เหตุผลในการถอดถอน',
    paymentCount: 'จำนวนสินเชื่อ',
    paymentAmount: 'จำนวนเงินให้กู้',
    status: 'สถานะปัจจุบัน',
    statusPlaceholder: 'กรุณาเลือกสถานะ',
    updateTime: 'อัปเดตเวลา',
    action: 'การดำเนินการ',
    createPayrollBatch: 'สร้างล็อตเงินเดือนใหม่',
    payrollDetail: 'รายละเอียดเงินเดือน',
    batchBaseInfo: 'ข้อมูลพื้นฐานของ Pay Lot',
    batchDetailInfo: 'รายละเอียดล็อตการจ่ายเงิน',
    allCount: 'จำนวนแถบทั้งหมด',
    allAmount: 'จำนวนเงินทั้งหมด',
    effectiveCount: 'จำนวนแถบที่ถูกต้อง (ไม่ถูกยกเลิก)',
    effectiveAmount: 'จำนวนเงินที่ยังไม่หมดอายุ (ไม่มีการยกเลิก)',
    onlyRejectData: 'ดูเฉพาะข้อมูลการถอดถอน',
    waitRejectCount: 'จำนวนรายการที่รอการปฏิเสธ',
    groupId: 'กลุ่ม'
  },
  en: {
    keyword: 'Keyword',
    keywordPlaceholder: 'Please enter batch number or file name',
    uploadDate: 'UploadDate',
    batchNo: 'Batch No',
    fileName: 'File Name',
    creatorName: 'Creator Name',
    createTime: 'Create Time',
    totalCount: 'Total Count',
    totalAmount: 'Total Amount',
    rejectCount: 'Reject Count',
    rejectReason: 'Reject Reason',
    paymentCount: 'Payment Count',
    paymentAmount: 'Payment Amount',
    status: 'Status',
    statusPlaceholder: 'Please select status ',
    updateTime: 'Update Time',
    action: 'Action',
    createPayrollBatch: 'Create Payroll Batch',
    payrollDetail: 'Payroll Detail',
    batchBaseInfo: 'Batch Base Info',
    batchDetailInfo: 'Batch Detail Info',
    allCount: 'All Count',
    allAmount: 'All Amount',
    effectiveCount: 'Effective Count (not cancelled)',
    effectiveAmount: 'Effective Amount (not cancelled)',
    onlyRejectData: 'Only Reject Data',
    waitRejectCount: 'Wait Reject Count',
    groupId: 'Group'
    
  }
}
